import { gql } from "@apollo/client";

const CREATE_EVALUACION_PROFESIONAL = gql`
    mutation createEvaluacionProfesional($input: AddEvaluacionProfesionalInput!){
    createEvaluacionProfesional(input: $input) {
      success
      error
      valorEsperado
    }
}
`;

export default CREATE_EVALUACION_PROFESIONAL;